import type { AvatarConfig } from '../../donorAvatar/avatar-catalog'

export const THROW_RELEASE = 600
const smooth = (value: number) => {
  const t = Math.max(0, Math.min(1, value))
  return t * t * (3 - 2 * t)
}
export function throwPose(at: number, config: AvatarConfig) {
  const angle =
    at < 300
      ? -60 - 75 * smooth(at / 300)
      : -135 + 40 * smooth((at - 300) / 300) + 35 * smooth((at - 600) / 500)
  const right = 240 - (config.body === 'slim' ? 70 : config.body === 'broad' ? 43 : 56)
  const radians = (angle * Math.PI) / 180
  return {
    angle,
    x: 12 - Math.max(0, at - 1200) * 0.17,
    handX: 12 + (right - 6 + 6 * Math.cos(radians) - 58 * Math.sin(radians)) * 0.34 + 14,
    handY: 140 + (216 + 6 * Math.sin(radians) + 58 * Math.cos(radians)) * 0.34,
  }
}
